
export default {

  createUrl(tipo, id){
    return `${window.server.API}/api/v2/onr/meio-pagamento/public/${tipo}/${id}/gerar-pix`;
  }

}
